import { useAuth } from 'hooks/UseAuth'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

const useOpenedFoldersNamespaceKey = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const auth = useAuth()
  return `workspace-${currentWorkspaceId}-user-${auth?.id}-tree`
}

export { useOpenedFoldersNamespaceKey }
